import React, { Component } from 'react'
import { bindActionCreators} from 'redux'
import { connect } from 'react-redux'
import _ from 'lodash'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'
import { Breadcrumb, Segment, Label, Icon,  Button, Tab, Message, Table, List } from 'semantic-ui-react'
import {
    loadRelationById,
    updateRelationModelInStore
} from '../../actions/relation'
import {api} from '../../api'
import Dls from '../../lib'
import AddressTab from './parts/AddressTab'
import ContactTab from './parts/ContactTab'
import PricingTab from './parts/PricingTab'
import OrderHistoryTab from './parts/OrderHistoryTab'
import NoteTab from "./parts/NoteTab";

class RelationViewPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false
        }
    }
    //access router
    //this.props.history.push('/dashboard')
    componentDidMount() {
        const {jwt} = this.props;
        const {id, type} = this.props.match.params;
        if (parseInt(id) !== parseInt(this.props.model.id)) {
            this.props.loadRelationById(jwt, id, _.upperFirst(type)).catch(err => {
                Dls.apiErrorAlert(err)
            });
        }
    }

    getTermName = () => {
        const {terms} = this.props;
        const {term_id} = this.props.model;
        const index = _.findIndex(terms, i => {
            return i.value === term_id
        })

        if (index > -1) {
            return terms[index].text
        }
    }

    getTaxName = () => {
        const {taxes} = this.props;
        const {tax_id} = this.props.model;
        const index = _.findIndex(taxes, i => {
            return i.value === tax_id
        })

        if (index > -1) {
            return taxes[index].text
        }
    }

    onQbSyncClick = () => {
        console.log('sync qb')
    }

    onWooSyncClick = () => {
        console.log('sync woo')
    }

    onLinksSyncClick = () => {

    }

    sendToShopify = () => {
        //this.props.updateRelationModelInStore('shopify_id', val);
        this.setState({
            loading: true
        });
        api.relation.toShopify(this.props.jwt, this.props.model.id).then(res => {
            this.props.updateRelationModelInStore('shopify_id', res.data.data)
            this.setState({
                loading: false
            });
        }).catch(err => {
            Dls.apiErrorAlert(err)
            this.setState({
                loading: false
            });
        });
    }

    getRep = () => {
        const {model, users} = this.props;
        const userIndex = _.findIndex(users, u => {
            return parseInt(u.value, 10) === parseInt(model.rep_id);
        });
        if (userIndex > -1) {
            return users[userIndex].text
        }
        return "";
    }

    render() {
        const {model} = this.props;
        const {type} = this.props.match.params;
        return (
            <div>
                {_.isEmpty(model) ? <div></div> :
                    <div>
                        <div className="row">
                            <div className="col-md-8">
                                <Breadcrumb size="huge">
                                    <Breadcrumb.Section>
                                        Relations
                                    </Breadcrumb.Section>
                                    <Breadcrumb.Divider />
                                    <Breadcrumb.Section>
                                        <Link
                                            to={`/${_.toLower(type)}s/${Dls.pagination.relations(type)}`}
                                        >
                                            {_.upperFirst(type)}s
                                        </Link>
                                    </Breadcrumb.Section>
                                    <Breadcrumb.Divider />
                                    <Breadcrumb.Section>
                                        {model.id ? model.company_name : `Create New ${type}`}
                                    </Breadcrumb.Section>
                                </Breadcrumb>
                            </div>
                            <div className="col-md-4">
                                <div style={{ float: "right" }}>
                                    <Button size="mini"
                                        color="teal"
                                        icon as={Link}
                                        to={`/${_.lowerCase(type)}s/${model.id}/edit/${_.lowerCase(type)}`}>
                                        <Icon name="users" />&nbsp;
                                        Edit
                                    </Button>

                                    <Button size="mini" color="teal" icon as={Link} to={`/${_.lowerCase(type)}s/new/edit/${_.lowerCase(type)}`}>
                                        <Icon name="users" />&nbsp;
                                        Create New
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <div className="row" style={{marginTop: '5px'}}>
                            <div className="col-md-12">
                                <Segment raised>
                                    <Label color='teal' ribbon>
                                        Account
                                    </Label>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div style={{marginTop: '3px'}}>
                                                Company Name: <br />
                                                <strong>{model.company_name ? model.company_name : <br />}</strong>
                                            </div>
                                            <div style={{marginTop: '3px'}}>
                                                Company Status: <br />
                                                <strong>{model.status ? model.status : <br />}</strong>
                                            </div>
                                            <div style={{marginTop: '3px'}}>
                                                Email: <br />
                                                <strong>{model.email ? model.email : <br />}</strong>
                                            </div>
                                            <div style={{marginTop: '3px'}}>
                                                Integration: <br />
                                                {model.acct_id ?
                                                    <Label size='mini' as={Button} onClick={() => this.onQbSyncClick()} color='green'>QB</Label> :
                                                    <Label size='mini' as={Button} onClick={() => this.onQbSyncClick()} color='red'>QB</Label>}
                                                {model.woo_id ?
                                                    <Label size='mini' as={Button} onClick={() => this.onWooSyncClick()} color='green'>Woo</Label> :
                                                    <Label size='mini' as={Button} onClick={() => this.onWooSyncClick()} color='red'>Woo</Label>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div style={{marginTop: '3px'}}>
                                                Account: <br />
                                                <strong>{model.account ? model.account : <br />}</strong>
                                            </div>
                                            <div style={{marginTop: '3px'}}>
                                                First Name: <br />
                                                <strong>{model.given_name ? model.given_name : <br />}</strong>
                                            </div>
                                            <div style={{marginTop: '3px'}}>
                                                Last Name: <br />
                                                <strong>{model.family_name ? model.family_name : <br />}</strong>
                                            </div>
                                            <div style={{marginTop: '3px'}}>
                                                Phone: <br />
                                                <strong>{model.phone ? model.phone : <br />}</strong>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div style={{marginTop: '3px'}}>
                                                Default Tax: <br /><strong>{this.getTaxName()}</strong><br />
                                            </div>
                                            <div style={{marginTop: '3px'}}>
                                                Default Term: <br /><strong>{this.getTermName()}</strong><br />
                                            </div>
                                            <div style={{marginTop: '3px'}}>
                                                Default Currency: <br />
                                                <strong>{model.currency ? model.currency : <br />}</strong>
                                            </div>
                                            <div style={{marginTop: '3px'}}>
                                                Account Rep: <br />
                                                <strong>{this.getRep(model.rep_id)}</strong>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div style={{marginTop: '3px'}}>
                                                Qualified Name (QB): <br />
                                                <strong>{model.qualified_name ? model.qualified_name : <br />}</strong>
                                            </div>
                                            <div style={{marginTop: '3px'}}>
                                                Display Name (QB): <br />
                                                <strong>{model.display_name ? model.display_name : <br />}</strong>
                                            </div>
                                            <div style={{marginTop: '3px'}}>
                                                Check Name (QB): <br />
                                                <strong>{model.check_name ? model.check_name : <br />}</strong>
                                            </div>
                                            <div style={{marginTop: '3px'}}>
                                                Quickbook ID: <br />
                                                <strong>{model.acct_id ? model.acct_id : <br />}</strong>
                                            </div>
                                        </div>
                                    </div>
                                </Segment>
                            </div>
                        </div>
                        <div className="row" style={{marginTop: '10px'}}>
                            <div className="col-md-12">
                                <Segment raised>
                                    <Label color='teal' ribbon>
                                        Details
                                    </Label>
                                    <div
                                        style={{marginTop: '5px'}}
                                    >
                                        <Tab panes={[
                                            {menuItem: 'Addresses', render: () => <AddressTab relationId={model.id ? model.id : 0} addresses={model.addresses} />},
                                            {menuItem: 'Contacts', render: () => <ContactTab relationId={model.id} contacts={model.contacts} />},
                                            {menuItem: 'Inventory Pricing', render: () => <PricingTab relationId={model.id} type={type} prices={model.special_pricings} />},
                                            model.type === 'Customer' ? {menuItem: 'Order History', render: () => <OrderHistoryTab id={model.id} jwt={this.props.jwt} />} : null,
                                            {menuItem: 'Notes', render: () => <NoteTab notes={_.isArray(model.notes) ? model.notes : []} jwt={this.props.jwt} relationId={model.id}/>}
                                        ]} menu={{ pointing: true }}>
                                        </Tab>
                                    </div>
                                </Segment>
                            </div>
                        </div>
                        {model.type === 'Customer' ? <div className="row" style={{marginTop: '10px'}}>
                            <div className="col-md-12">
                                <Segment raised>
                                    <Label color='teal' ribbon>
                                        Shopify
                                    </Label>
                                    <Message>
                                        <Message.Header>
                                            Shopify Mapping
                                        </Message.Header>
                                        <p>* Shopify reuqires email and phone number per customer to be unique.</p>
                                    {model.shopify_id ? <Message.Header>Shopify Ready (ID: {model.shopify_id})</Message.Header> : <Message.Header>Not In Shopify</Message.Header>}
                                        {!model.shopify_id ? <div>
                                            <p><Button color='teal' size='mini' loading={this.state.loading} disabled={this.state.loading} onClick={() => {
                                                this.sendToShopify()
                                            }}>Sync Shopify</Button></p>
                                            <p>
                                                By clicking this button, the system will create this customer in your Shopify store. The customer will receive an email from Shopify
                                                to activate his or her account and set up his or her password.
                                            </p>
                                        </div>: null}
                                    </Message>
                                    {model.shopify_id ? <Message>
                                        <Message.Header>
                                            Need Customer Pricing? Use the following steps in Bold Custom Pricing app.
                                        </Message.Header>
                                        <List>
                                            <List.Item>Login Shopify admin dashboard</List.Item>
                                            <List.Item>Go to Apps => Bold Custom Pricing</List.Item>
                                            <List.Item>Click on Manage Tags (2nd on the black left side menu)</List.Item>
                                            <List.Item>Go to the bottom of the table, start a new empty row by entering the following</List.Item>
                                            <List.Item>
                                                <Table>
                                                    <Table.Header>
                                                        <Table.Row>
                                                            <Table.HeaderCell>
                                                                Tag
                                                            </Table.HeaderCell>
                                                            <Table.HeaderCell>
                                                                Description
                                                            </Table.HeaderCell>
                                                            <Table.HeaderCell>
                                                                Charge Tax
                                                            </Table.HeaderCell>
                                                            <Table.HeaderCell>
                                                                Auto Tagging Rules
                                                            </Table.HeaderCell>
                                                            <Table.HeaderCell>
                                                                Default Discount
                                                            </Table.HeaderCell>
                                                        </Table.Row>
                                                    </Table.Header>
                                                    <Table.Body>
                                                        <Table.Row>
                                                            <Table.Cell>
                                                                dls-{model.id}
                                                            </Table.Cell>
                                                            <Table.Cell>
                                                                {model.company_name}
                                                            </Table.Cell>
                                                            <Table.Cell>
                                                                Product Default
                                                            </Table.Cell>
                                                            <Table.Cell>
                                                                None
                                                            </Table.Cell>
                                                            <Table.Cell>
                                                                0
                                                            </Table.Cell>
                                                        </Table.Row>
                                                    </Table.Body>
                                                </Table>
                                            </List.Item>
                                            <List.Item>Click on "Add New Tag"</List.Item>
                                            <List.Item>
                                                In above "Inventory Pricing" tab, assign special pricing to this customer
                                            </List.Item>
                                            <List.Item>
                                                <strong>Refresh your page</strong>
                                            </List.Item>
                                            <List.Item>
                                                Go back to "Inventory Pricing" tab, click on "Shopify Pricing CSV". This will generate a file called
                                                &nbsp;<strong>dls-{model.id}.csv</strong>
                                            </List.Item>
                                            <List.Item>Click on Import/Export (5th on the black left side menu)</List.Item>
                                            <List.Item>Upload this new <strong>dls-{model.id}.csv</strong> file in Bold Custom Pricing app.</List.Item>
                                        </List>
                                    </Message> : null}
                                </Segment>
                            </div>
                        </div> : null}
                    </div>
                }
            </div>
        )
    }
}

RelationViewPage.propTypes = {
    history: PropTypes.shape({
       push: PropTypes.func.isRequired
    }).isRequired,
    loadRelationById: PropTypes.func.isRequired,
    updateRelationModelInStore: PropTypes.func.isRequired,
    taxes: PropTypes.array.isRequired,
    terms: PropTypes.array.isRequired,
    users: PropTypes.array.isRequired
};

function mapStateToProps(state) {
    return {
        jwt: state.auth.jwt,
        model: state.relation.model,
        taxes: state.system.resources.taxes,
        users: state.system.resources.users,
        terms: state.system.resources.terms
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        loadRelationById,
        updateRelationModelInStore
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(RelationViewPage)



// WEBPACK FOOTER //
// ./src/components/relations/RelationView.js